export const REQUEST_STATUSES = {
  FAILED: "failed",
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
} as const;

export type REQUEST_STATUSES = (typeof REQUEST_STATUSES)[keyof typeof REQUEST_STATUSES];
